import '../Styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1>Privacy Policy for WEGO HOLIDAY HOMES LTD</h1>
        <p className="last-updated">Last updated: November 17, 2025</p>

        <p>
          At Wego Holiday Homes Ltd, one of our main priorities is the privacy of our visitors. This Privacy Policy document outlines the types of information collected and recorded by Wego Holiday Homes Ltd, as well as how we use it.
        </p>

        <p>
          If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us through email.
        </p>

        <p>
          This privacy policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collected by Wego Holiday Homes Ltd. This policy is not applicable to any information collected offline or via channels other than this website.
        </p>

        <h2>Consent</h2>
        <p>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</p>

        <h2>Information We Collect</h2>
        <p>
          The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.
        </p>
        <p>
          If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.
        </p>

        <h2>How We Use Your Information</h2>
        <p>We use the information we collect in various ways, including to:</p>
        <ul>
          <li>Provide, operate, and maintain our website</li>
          <li>Improve, personalize, and expand our website</li>
          <li>Understand and analyze how you use our website</li>
          <li>Develop new products, services, features, and functionality</li>
          <li>Communicate with you, either directly or through one of our partners, including for customer service, updates, and marketing purposes</li>
          <li>Send you emails</li>
          <li>Find and prevent fraud</li>
        </ul>

        <h2>Log Files</h2>
        <p>
          Wego Holiday Homes Ltd follows a standard procedure of using log files. These files log visitors when they visit websites. The information collected includes internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any personally identifiable information. The purpose is for analyzing trends, administering the site, tracking users' movement, and gathering demographic information.
        </p>

        <h2>Cookies and Web Beacons</h2>
        <p>
          Like any other website, Wego Holiday Homes uses ‘cookies’. These cookies store information including visitors' preferences and the pages visited. The information is used to optimize the user experience by customizing web page content based on browser type and/or other information.
        </p>

        <h2>CCPA Privacy Rights (Do Not Sell My Personal Information)</h2>
        <p>Under the CCPA, California consumers have the right to:</p>
        <ul>
          <li>Request disclosure of the categories and specific pieces of personal data collected</li>
          <li>Request deletion of any personal data collected</li>
          <li>Request that we do not sell your personal data</li>
        </ul>
        <p>If you make a request, we have one month to respond. To exercise these rights, please contact us.</p>

        <h2>GDPR Data Protection Rights</h2>
        <p>We want to ensure you are fully aware of your data protection rights. Every user is entitled to:</p>
        <ul>
          <li><strong>Right to access</strong> – Request copies of your personal data (small fee may apply)</li>
          <li><strong>Right to rectification</strong> – Request correction or completion of inaccurate/incomplete data</li>
          <li><strong>Right to erasure</strong> – Request deletion of your personal data, under certain conditions</li>
          <li><strong>Right to restrict processing</strong> – Request restriction of processing, under certain conditions</li>
          <li><strong>Right to object to processing</strong> – Object to our processing of your personal data, under certain conditions</li>
          <li><strong>Right to data portability</strong> – Request transfer of your data to another organization or directly to you, under certain conditions</li>
        </ul>
        <p>If you make a request, we have one month to respond. To exercise these rights, please contact us.</p>

        <h2>Children's Information</h2>
        <p>
          Another priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.
        </p>
        <p>
          Wego Holiday Homes does not knowingly collect Personal Identifiable Information from children under the age of 13. If you believe your child provided this information on our website, please contact us immediately and we will promptly remove such information from our records.
        </p>

        <div className="contact-footer">
          <p>For any questions regarding this Privacy Policy, please contact us at:</p>
          <p className="email">info@wegoholidayhomes.com</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;